const SWATCH_COLORS = {
  'ピンク':     { bg: '#ffeae9', text: '#333333' },
  'ホワイト':   { bg: '#ffffff', text: '#333333', border: true },
  'ネイビー':   { bg: '#233b58', text: '#ffffff' },
  'ベージュ':   { bg: '#f0ddc5', text: '#333333' },
  'ブルー':     { bg: '#abe1ed', text: '#333333' },
  'アイボリー': { bg: '#F5F0DC', text: '#333333', border: true },
  'グレー':     { bg: '#9E9E9E', text: '#ffffff' },
  'ブラック':   { bg: '#222222', text: '#ffffff' },
  'イエロー':   { bg: '#FEFFCC', text: '#333333' },
  'グリーン':   { bg: '#DFF7EC', text: '#333333' },
  'ラベンダー': { bg: '#eee3ff', text: '#333333' },
  'アプリコット': { bg: '#ffe8de', text: '#333333' },
};

function applySwatchColors() {
  document.querySelectorAll('label.variant-option__button-label').forEach(label => {
    const input = label.querySelector('input');
    if (!input) return;
    const value = input.value.trim();
    const color = SWATCH_COLORS[value];
    if (!color) return;

    label.style.setProperty('background-color', color.bg, 'important');
    label.style.setProperty('color', color.text, 'important');
    if (color.border) {
      label.style.setProperty('box-shadow', 'inset 0 0 0 1px #cccccc', 'important');
    }

    const pill = label.querySelector('.variant-option__button-label__pill');
    if (pill) {
      pill.style.setProperty('background', color.bg, 'important');
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', applySwatchColors);
} else {
  applySwatchColors();
}

new MutationObserver(applySwatchColors).observe(document.body, {
  childList: true,
  subtree: true,
});
